import { StyleSheet } from 'react-native';
import Colors from './Shared/Colors';

const PaginatorStyles = StyleSheet.create({
    wrapper: {
        alignItems: "center",
        marginVertical: 16,
    },
    paginationInfoDiv: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 30,
        width: '100%',
    },
    summary: {
        fontSize: 14,
        color: Colors.darkGreen,
        marginBottom: 8,
    },
    paginationBar: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 16,
    },
    navButton: {
        backgroundColor: Colors.darkGreen,
        alignItems: "center",
        justifyContent: "center",
        width: 26,
        height: 26,
        marginHorizontal: 4,
        borderRadius: 100,
    },
    disabled: {
        backgroundColor: Colors.white,
        borderColor: Colors.gray,
        borderWidth: 2,
        opacity: 0.4,
    },
    navText: {
        color: Colors.white,
        height: 15,
        width: 15,
        fontWeight: "600",
        textAlign: "center",
    },
    pageNumberContainer: {
        flexDirection: "row",
        alignItems: "center",
        marginHorizontal: 8,
    },
    pageButton: {
        paddingHorizontal: 8,
        paddingVertical: 4,
        marginHorizontal: 2,
    },
    pageText: {
        color: Colors.darkGreen,
        fontSize: 16,
    },
    activePageText: {
        fontWeight: "700",
        fontSize: 24,
    },
    ellipsis: {
        marginHorizontal: 4,
        color: Colors.darkGreen,
        fontWeight: "600",
    },
});

export { PaginatorStyles };